// Ignore errors that are not actionable
export const sentryIgnoreErrors = [
  "TypeError: Failed to fetch",
  "TypeError: NetworkError when attempting to fetch resource.",
  "TypeError: Cancelled",
  "ResizeObserver loop limit exceeded",
  "drift is not defined",
  "Can't find variable: drift",
];
